module.exports = __webpack_public_path__ + "static/media/TV-off-image-3.0e7b7ece.jpg";